module.exports = __webpack_public_path__ + "img/female.1c350ae1.svg";